var _defs, _g, _ellipse, _ellipse2, _rect, _polygon, _rect2, _polygon2, _rect3, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArborPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515 431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: none;\n      }\n\n      .c {\n        fill: #ff940a;\n      }\n\n      .d {\n        fill: #8dffff;\n      }\n\n      .e {\n        fill: #2a1f00;\n      }\n\n      .f {\n        fill: aqua;\n      }\n\n      .f, .g, .h {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .g {\n        fill: #00bf25;\n      }\n\n      .h {\n        fill: #9f6b00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M514,117v110h-6.94c-25.17,114.95-127.56,201-250.06,201S32.11,341.95,6.94,227H0v204H515V117h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M257,428c122.5,0,224.89-86.05,250.06-201H6.94c25.17,114.95,127.56,201,250.06,201Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "507.06 227 514 227 514 117 0 117 0 227 6.94 227 507.06 227"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 329,
    cy: 254,
    rx: 115.5,
    ry: 61.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 342.5,
    cy: 213.5,
    rx: 58.5,
    ry: 10.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 103,
    y: 85,
    width: 32,
    height: 186,
    rx: 16,
    ry: 16
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "149.8 6 78.2 6 42.41 68 78.2 130 149.8 130 185.59 68 149.8 6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 197.2,
    y: 69.86,
    width: 28.1,
    height: 163.31,
    rx: 14.05,
    ry: 14.05
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "238.29 .5 175.43 .5 144 54.94 175.43 109.37 238.29 109.37 269.71 54.94 238.29 .5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 164.59,
    y: 125.52,
    width: 33.83,
    height: 196.65,
    rx: 16,
    ry: 16
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "214.07 42 138.38 42 100.53 107.55 138.38 173.1 214.07 173.1 251.91 107.55 214.07 42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArborPurple);
export default __webpack_public_path__ + "static/media/arbor-purple.c66a9009e287d2f2860ed2c84b524500.svg";
export { ForwardRef as ReactComponent };